import { Paper, Stack, styled } from '@mui/material';

export const FormWrapper = styled(Paper)(({ theme: { spacing } }) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: spacing(3),
  gap: spacing(3),
}));

export const FormSectionWrapper = styled(Stack)(({ theme: { spacing } }) => ({
  gap: spacing(2),
}));
